import { useGetMyProfile } from 'services/hooks/user';
import { useGetBankAccountVerifications, useGetUsersIdentityVerifications } from 'services/hooks/verification';

export function useCheckVerificationsComplete() {
  const { data: profileData, isFetched: isFetchedProfile } = useGetMyProfile();
  const { data: identityData, isFetched: isFetchedIdentity } = useGetUsersIdentityVerifications(profileData?.id);
  const { data: bankAccountData, isFetched: isFetchedBankAccount } = useGetBankAccountVerifications(profileData?.id);

  const isFetched = isFetchedProfile && isFetchedIdentity && isFetchedBankAccount;
  const isIdentityVerificationCompleted = Boolean(identityData);
  const isEmailVerificationCompleted = profileData?.verified ?? false;
  const isBankAccountVerificationCompleted = bankAccountData?.status === 'verified';
  const isAllVerificationCompleted =
    isBankAccountVerificationCompleted && isEmailVerificationCompleted && isIdentityVerificationCompleted;
  const isWithdrawable = isAllVerificationCompleted;
  const isConvertibleToBubble = isAllVerificationCompleted;

  return {
    isFetched,
    isBankAccountVerificationCompleted,
    isIdentityVerificationCompleted,
    isEmailVerificationCompleted,
    isAllVerificationCompleted,
    isWithdrawable,
    isConvertibleToBubble,
  };
}
